<template>
    <div  style="height: 500px">
        <swiper v-if="!loading" :options="swiperOptionTop" class="gallery-top" ref="swiperTop">
            <swiper-slide
                class="swiper-slide-card"
                v-for="slide in images"
                :style="{ backgroundImage: 'url(' + slide.imagen_de_serie + ')' }"
                :key="slide.id"
            >
                <div class="content-slide"
                     @click="goToCategory(slide)">
                    {{ slide.titulo_slide}}
                </div>
            </swiper-slide>
            <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
            <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
        </swiper>
        <swiper v-if="!loading" :options="swiperOptionThumbs" class="gallery-thumbs" ref="swiperThumbs">
            <swiper-slide
                    v-for="slide in images"
                    :style="{ backgroundImage: 'url(' + slide.imagen_de_serie + ')' }"
                    :key="slide.id"
            ></swiper-slide>
        </swiper>
    </div>
</template>

<script>

    import 'swiper/css/swiper.min.css'
    import axios from 'axios/index'

    import { swiper, swiperSlide } from 'vue-awesome-swiper'

    export default {
        components: { swiper, swiperSlide },
        data() {
            return {
                swiperOptionTop: {
                    spaceBetween: 10,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                },
                swiperOptionThumbs: {
                    spaceBetween: 10,
                    slidesPerView: 'auto',
                    centeredSlides: true,
                    touchRatio: 0.2,
                    slideToClickedSlide: true
                },
                loading: true,
                images: []
            }
        },
        props: {
            cat_type: {
                type: String,
                default: ''
            },
            dataContent: {
                type: Object,
                default: () => {}
            }
        },
        methods: {
            goToCategory(slide) {
                console.log(slide);
                window.document.location.href='/sermon-category/' + slide.slug + '/'
            },
            getSermonCategories: function() {
                let url = '/wp-json/gsapi/v1/sermon_categories/' + this.cat_type
                axios.get(url).then( (response) => {
                    if ( response.status == 200 ) {
                        this.images = response.data;
                    }
                    else {
                        console.log(response);
                    }
                })
                    .catch(error => {
                        console.log(error)
                    });
            }
        },
        mounted() {
            if ( this.dataContent ) {
                this.images = this.dataContent;
            }
            else {
                this.getSermonCategories()
            }

            this.$nextTick(() => {
                const swiperTop = this.$refs.swiperTop.swiper
                const swiperThumbs = this.$refs.swiperThumbs.swiper
                swiperTop.controller.control = swiperThumbs
                swiperThumbs.controller.control = swiperTop
            })
            this.loading = false
        }
    }
</script>

<style lang="scss" scoped>
    .swiper-slide {
        display: flex;
        align-items: center;
        .content-slide {
            text-align: center;
            text-shadow: 1px 1px 1px #444;
            color: #fff;
            font-family: Roboto,sans-serif;
            font-weight: bolder;
            font-size: 4rem;
            padding: 15px 60px;
            width: 100%;
            word-break: break-word;
        }
    }

    .swiper-slide-card {
        cursor: pointer;
    }
    .swiper-container {
        background-color: #000;
    }
    .swiper-slide {
        background-size: cover;
        background-position: center;
    }
    .gallery-top {
        height: 80%!important;
        width: 100%;
    }
    .gallery-thumbs {
        height: 20%!important;
        box-sizing: border-box;
        padding: 10px 0;
    }
    .gallery-thumbs .swiper-slide {
        width: 25%;
        height: 100%;
        opacity: 0.4;
    }
    .gallery-thumbs .swiper-slide-active {
        opacity: 1;
    }
</style>
